import React from "react";
import { Box } from "@mui/material";

const TEAL = "#00a6b2";
const AMBER = "#b8860b";

// Vertical strip pinned to the left edge of a `position: relative`
// container, text rotated bottom-to-top. Renders nothing for promoStatus
// "none"/undefined so callers can use it unconditionally.
const PromoRibbon = ({ promoStatus }) => {
  if (promoStatus !== "applied" && promoStatus !== "pending") return null;

  const label = promoStatus === "applied" ? "Promo Applied" : "Promo Pending";
  const bg = promoStatus === "applied" ? TEAL : AMBER;

  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        width: 28,
        bgcolor: bg,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "none",
        zIndex: 2,
        boxShadow: "2px 0 6px rgba(0,0,0,0.2)",
      }}
    >
      <Box
        sx={{
          writingMode: "vertical-rl",
          transform: "rotate(180deg)",
          color: "#fff",
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: 0.5,
          textTransform: "uppercase",
          whiteSpace: "nowrap",
        }}
      >
        {label}
      </Box>
    </Box>
  );
};

export default PromoRibbon;
